import { render, staticRenderFns } from "./CostDepart.vue?vue&type=template&id=0676e826&scoped=true&"
import script from "./CostDepart.vue?vue&type=script&lang=js&"
export * from "./CostDepart.vue?vue&type=script&lang=js&"
import style0 from "./CostDepart.vue?vue&type=style&index=0&id=0676e826&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0676e826",
  null
  
)

export default component.exports